import React, { forwardRef } from 'react';
import ArrowDownRightPairedWithText from '../text-pairing/ArrowDownRight';
const ArrowDownRight = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 19 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M18 4.027h-1.492v14.415L1.56 3.502.503 4.56l14.94 14.947H1.027V21H18z", fill: "currentColor" }))));
ArrowDownRight.displayName = 'ArrowDownRight';
// @ts-ignore;
const iconData = {
    glyph: ArrowDownRight,
    group: 'navigation',
    textPairingGlyph: ArrowDownRightPairedWithText,
    followDirection: true,
};
export default iconData;
